/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function CloseIcon(props: IconProps & { size?: number }) {
	const { color, size = 16 } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fill={color} fillRule="nonzero" transform="translate(-895 -216)">
					<path d="M903.795 224l7.04 7.04a.562.562 0 11-.794.795l-7.041-7.04-7.04 7.04a.561.561 0 11-.795-.795l7.04-7.04-7.04-7.04a.562.562 0 11.794-.795l7.041 7.04 7.04-7.04a.562.562 0 11.795.795l-7.04 7.04z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default CloseIcon;
